export const getYearSince = (startYear: number): number => {
  const years = new Date().getFullYear() - startYear;
  const d = years / 10;
  const f = Math.floor(d);
  return f * 10 + (d - f >= 0.5 ? 5 : 0);
};
